var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-library-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-library-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-library-modal-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "wkb-library-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
              _c("header", { staticClass: "wkb-library-head" }, [
                _c("div", { staticClass: "wkb-library-head-row" }, [
                  _c("h2", { attrs: { id: "wkb-library-modal-title" } }, [
                    _vm._v("My library"),
                  ]),
                  _c("div", { staticClass: "wkb-library-transfer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "wkb-library-action",
                        attrs: {
                          type: "button",
                          disabled: !_vm.records.length,
                        },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v(" Back up library… ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "wkb-library-action",
                        attrs: { type: "button" },
                        on: { click: _vm.onImportClick },
                      },
                      [_vm._v(" Restore library backup… ")]
                    ),
                    _c("input", {
                      ref: "importFileInput",
                      staticClass: "wkb-library-file-input",
                      attrs: { type: "file", accept: ".json,application/json" },
                      on: { change: _vm.onImportFileChange },
                    }),
                  ]),
                ]),
                _vm._m(0),
                _vm._m(1),
                _vm.transferMessage
                  ? _c("p", { staticClass: "wkb-library-transfer-message" }, [
                      _vm._v(" " + _vm._s(_vm.transferMessage) + " "),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "wkb-library-body" }, [
                !_vm.records.length
                  ? _c("p", { staticClass: "wkb-library-empty" }, [
                      _vm._v(
                        " No saved graphs in this browser yet. Build a graph on the canvas and use "
                      ),
                      _c("strong", [_vm._v("Manage → Save graph to library…")]),
                      _vm._v(" when that option is available. "),
                    ])
                  : _c(
                      "ul",
                      { staticClass: "wkb-library-list" },
                      _vm._l(_vm.records, function (record) {
                        return _c(
                          "li",
                          { key: record.id, staticClass: "wkb-library-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "wkb-library-item-main" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "wkb-library-item-title" },
                                  [_vm._v(_vm._s(record.label))]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "wkb-library-item-meta" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.formatCounts(record)) +
                                        " · " +
                                        _vm._s(_vm.formatWhen(record.savedAt)) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "wkb-library-item-actions" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wkb-library-action wkb-library-action-primary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("load", record)
                                      },
                                    },
                                  },
                                  [_vm._v(" Open on canvas ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "wkb-library-action",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("duplicate", record)
                                      },
                                    },
                                  },
                                  [_vm._v(" Duplicate ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wkb-library-action wkb-library-action-danger",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("delete", record)
                                      },
                                    },
                                  },
                                  [_vm._v(" Remove from library ")]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-library-storage-note" }, [
      _vm._v(" My library lists graphs saved in "),
      _c("strong", [_vm._v("this browser only")]),
      _vm._v(
        " (local storage). Graph layout and links are stored; inspector results are not. Use "
      ),
      _c("strong", [_vm._v("Manage → Export graph")]),
      _vm._v(
        " on the canvas for a full graph file that can rebuild the session with inspection data. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-library-transfer-note" }, [
      _c("strong", [_vm._v("Back up library")]),
      _vm._v(
        " downloads every My library graph as JSON for backup or another browser. "
      ),
      _c("strong", [_vm._v("Restore library backup")]),
      _vm._v(
        " merges those entries here; duplicate IDs are saved as new copies. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }